<!-- ══════════════════════════════════════════════════════════════════════════
     LAS CONDICIONES COMERCIALES, PASO A PASO (CONTRATO-REDISENO-ALTAS.md, «C»).

     Cinco pasos: Plazo y comisión · Cobros (el cargo por uso primero) · Modelos ·
     Riesgo y liquidación · Revisar (vigencia, resumen, venta de ejemplo y, en
     'version', los cambios respecto de la vigente con el «no estás cambiando
     nada» justo encima del botón). Es lo que tenía `comercios-condiciones-form`,
     redistribuido: ninguna regla se reescribió.

     Cero `Swal` y cero modales: la confirmación de crear es la misma barra del
     pie, en dos pasos; los errores van bajo el campo o en esa barra.

     `(input)` y `(change)` suben desde cualquier campo hasta el contenedor: ahí
     se guarda el borrador en sessionStorage, sin tocar campo por campo.
     ══════════════════════════════════════════════════════════════════════════ -->
<div class="space-y-[24px]" (input)="guardarBorrador()" (change)="guardarBorrador()">

  <app-riel-pasos [pasos]="riel" [navegable]="true" rotulo="Pasos de las condiciones"
                  (elegir)="irA($event)"></app-riel-pasos>

  <div class="kb-aviso kb-aviso-info" *ngIf="borradorRetomado">
    <i class="fas fa-history mt-0.5" aria-hidden="true"></i>
    <div class="flex flex-1 flex-wrap items-center justify-between gap-[12px]">
      <p class="m-0">Se retomó lo que habías cargado sin guardar, a las
        <span class="tabular-nums">{{ borradorRetomado | date:'HH:mm' }}</span>.</p>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="descartarBorrador()">
        <i class="fas fa-undo" aria-hidden="true"></i>Empezar de nuevo
      </button>
    </div>
  </div>

  <div>
    <h2 #tituloPaso tabindex="-1" class="cp-titulo m-0 text-lg font-semibold leading-tight">
      {{ PASOS[indice].nombre }}
    </h2>
    <p class="m-0 mt-[4px] text-sm text-muted-foreground">{{ fraseDelPaso(paso) }}</p>
  </div>

  <ng-container [ngSwitch]="paso">

    <!-- ══ 1 · Plazo y comisión ═══════════════════════════════════════════════
         🔴 REGLA DE JUAN, 2026-09-28: una versión lleva UN solo plazo de cobro,
         sin «agregar plazo». El plazo define el período que se liquida y ES la
         comisión, porque cobrar rápido cuesta más. -->
    <!-- Propuesta C (Mario, 30-oct: «esta muy desordenada y dificil de entender»): como «Tipo de contrato», las preguntas a
         la izquierda y «Así queda» al lado. Sin uso de plataforma: «se define adelante», en «Cobros» (PLT-01). -->
    <section *ngSwitchCase="'plazo'" class="cp-tipo max-w-[1080px]">
      <div class="space-y-[26px]">

        <div class="space-y-[12px]">
          <span class="cp-vigente" *ngIf="vigente && !esPropuesta">
            <i class="fas fa-history" aria-hidden="true"></i>Hoy rige
            <b class="tabular-nums">{{ comisionVigente() }}</b><span class="font-mono text-xs">{{ vigente.version.code }}</span>
          </span>

          <div class="kb-aviso kb-aviso-info" *ngIf="vigenteConVariosPlazos">
            <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
            <div>
              <p class="kb-aviso-titulo">La {{ esPropuesta ? 'propuesta cargada' : 'vigente' }} es de antes de esta regla</p>
              <p class="m-0">Tenía varios plazos de cobro; esto arrancó con el que estaba marcado por
                 omisión. Los demás no se copian: para tenerlos hay que crear una versión por cada uno.</p>
            </div>
          </div>

          <!-- 🔴 TARIFARIO ESTÁNDAR (Mario, 07-oct-2026): el plazo se elige de la tabla única y de ahí
               salen nombre, comisión, forma y base, sin editar. Personalizar es «Condición especial». -->
          <div class="kb-aviso kb-aviso-peligro" *ngIf="errorTabla" role="alert">
            <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
            <div><p class="m-0">{{ errorTabla }}</p></div>
          </div>
          <div class="kb-aviso kb-aviso-alerta" *ngIf="avisoTabla">
            <i class="fas fa-exclamation-triangle mt-0.5" aria-hidden="true"></i>
            <div><p class="m-0">{{ avisoTabla }}</p></div>
          </div>
        </div>

        <fieldset id="cpPlazoTabla" class="space-y-[10px]">
          <legend class="cp-preg"><span class="cp-preg-n">1</span>¿En qué plazo se le paga?</legend>
          <p class="kb-hint !mt-0" *ngIf="form.especial.activo">Se usa la condición especial de abajo.</p>
          <ng-container *ngIf="!form.especial.activo">
            <p class="kb-hint !mt-0" *ngIf="!tabla">Cargando la tabla…</p>
            <div class="grid grid-cols-1 gap-[12px] sm:grid-cols-2">
              <label *ngFor="let fila of tabla?.rows; let i = index" [for]="'cpPlazo' + i"
                     class="flex cursor-pointer gap-3 rounded-xl border bg-card p-4 transition-colors hover:bg-accent/40"
                     [ngClass]="filaTabla && claveDeFila(filaTabla) === claveDeFila(fila) ? 'border-primary bg-primary/5 ring-1 ring-primary cp-op-si' : 'border-border'">
                <input [id]="'cpPlazo' + i" type="radio" name="cpPlazo" class="kb-radio mt-0.5" [checked]="filaTabla && claveDeFila(filaTabla) === claveDeFila(fila)" (change)="elegirPlazo(claveDeFila(fila))">
                <span class="cp-op-ico"><i class="fas" [ngClass]="fila.unit === 'HORAS' ? 'fa-bolt' : 'fa-calendar-alt'" aria-hidden="true"></i></span>
                <span class="min-w-0 flex-1"><span class="text-sm font-semibold text-foreground">{{ fila.label || textoPlazo(fila) }}</span>
                  <span class="kb-hint block !mt-1">{{ textoPlazo(fila) }} {{ desdeCuando }}</span></span>
                <span class="cp-op-pct tabular-nums">{{ fila.commission_value }} %</span>
              </label>
            </div>
            <p class="kb-hint" *ngIf="tabla">De la tabla <span class="font-mono">{{ tabla?.version?.code }}</span>, en
              <a class="underline !text-foreground" routerLink="/console/parametros-sistema/tarifario">Parámetros → Tarifario de liquidación</a>.</p>
          </ng-container>
        </fieldset>

        <!-- La base de cálculo es una selección aparte en cada caso (Mario, 07-oct): no viene de la tabla y elegirla no
             vuelve especial la versión. CON-22 (21-oct) y Mario 28-oct: las opciones dependen del tipo (`opcionesBase`). -->
        <fieldset class="space-y-[10px]">
          <legend class="cp-preg"><span class="cp-preg-n">2</span>¿Sobre qué se calcula la comisión?</legend>
          <div id="cpBase" class="cp-seg cp-seg-grande" role="radiogroup" aria-label="Base de cálculo">
            <button type="button" *ngFor="let b of opcionesBase" role="radio" [attr.aria-checked]="form.plazo.base === b.v"
                    [class.cp-seg-si]="form.plazo.base === b.v" (click)="form.plazo.base = b.v; guardarBorrador()">{{ b.t }}</button>
          </div>
          <p class="kb-hint">{{ ayudaBase }}</p>
        </fieldset>

        <!-- PLZ-09 (Mario, 23-oct): si se liquida o no en fines de semana y feriados va junto al plazo. -->
        <fieldset class="space-y-[10px]">
          <legend class="cp-preg"><span class="cp-preg-n">3</span>¿Y los fines de semana y feriados?</legend>
          <div class="grid grid-cols-1 gap-[12px] sm:grid-cols-2">
            <label for="cpDiaHabil" class="flex cursor-pointer gap-3 rounded-xl border bg-card p-4 transition-colors hover:bg-accent/40"
                   [ngClass]="form.settlement.business_day_rule === 'NEXT_BUSINESS_DAY' ? 'border-primary bg-primary/5 ring-1 ring-primary cp-op-si' : 'border-border'">
              <input id="cpDiaHabil" type="radio" name="cpDiaHabil" value="NEXT_BUSINESS_DAY" class="kb-radio mt-0.5"
                     [(ngModel)]="form.settlement.business_day_rule">
              <span class="cp-op-ico"><i class="fas fa-calendar-check" aria-hidden="true"></i></span>
              <span><span class="text-sm font-semibold text-foreground">Día hábil siguiente</span>
                <span class="kb-hint block !mt-1">En fin de semana o feriado no se liquida: se paga el hábil siguiente, y eso no cuenta como atraso.</span></span>
            </label>
            <label for="cpDiaMismo" class="flex cursor-pointer gap-3 rounded-xl border bg-card p-4 transition-colors hover:bg-accent/40"
                   [ngClass]="form.settlement.business_day_rule === 'SAME_DAY' ? 'border-primary bg-primary/5 ring-1 ring-primary cp-op-si' : 'border-border'">
              <input id="cpDiaMismo" type="radio" name="cpDiaHabil" value="SAME_DAY" class="kb-radio mt-0.5"
                     [(ngModel)]="form.settlement.business_day_rule">
              <span class="cp-op-ico"><i class="fas fa-calendar-day" aria-hidden="true"></i></span>
              <span><span class="text-sm font-semibold text-foreground">Ese mismo día</span>
                <span class="kb-hint block !mt-1">También se liquida en fines de semana y feriados.</span></span>
            </label>
          </div>
          <p class="kb-hint">Lo dice el contrato del comercio.</p>
        </fieldset>

        <!-- La excepción, al final: otro plazo u otra comisión que no está en la tabla (CON-16). -->
        <div class="rounded-xl border transition-colors"
             [ngClass]="form.especial.activo ? 'border-amber-300 bg-amber-50/40 dark:border-amber-500/40 dark:bg-amber-500/5' : 'border-dashed border-border'">
          <label class="flex cursor-pointer items-start gap-3 px-4 py-3" for="cpEspecial">
            <input id="cpEspecial" type="checkbox" class="kb-radio mt-0.5 rounded" [ngModel]="form.especial.activo"
                   (ngModelChange)="cambiarEspecial($event)">
            <span class="min-w-0 flex-1 text-sm">
              <ng-container *ngIf="!form.especial.activo"><span class="text-muted-foreground">¿Este comercio no sigue la tabla?</span>
                <span class="font-medium text-foreground underline">Usar una condición especial</span>
                <span class="text-muted-foreground">: otro plazo u otra comisión; la versión queda marcada «Especial» y pide un motivo.</span></ng-container>
              <span class="flex flex-wrap items-center gap-2" *ngIf="form.especial.activo">
                <span class="font-medium text-foreground">Condición especial</span>
                <span class="kb-badge kb-badge-alerta">Especial</span>
              </span>
            </span>
          </label>
          <div class="space-y-4 border-t border-amber-200 px-4 pb-4 pt-4 dark:border-amber-500/30" *ngIf="form.especial.activo">
            <div>
              <label class="kb-label" for="cpEspecialMotivo">Motivo <span class="text-destructive">*</span></label>
              <textarea id="cpEspecialMotivo" class="kb-input" rows="2" placeholder="Por qué este comercio no sigue la tabla"
                        [(ngModel)]="form.especial.motivo"></textarea>
            </div>
            <div class="grid grid-cols-1 gap-[20px] sm:grid-cols-2">
              <!-- PLZ-04 (Mario, 23-oct): la condición especial se carga en horas o en días, igual que la tabla. -->
              <div>
                <label class="kb-label" for="cpPlazoDias">Plazo <span class="text-destructive">*</span></label>
                <div class="flex gap-2">
                  <input id="cpPlazoDias" type="number" min="1" step="1" class="kb-input min-w-0 flex-1 text-right tabular-nums"
                         [placeholder]="form.plazo.unit === 'HORAS' ? '24' : '7'" [(ngModel)]="valorPlazo">
                  <div class="kb-select-envoltorio w-[120px] shrink-0">
                    <select id="cpPlazoUnidad" class="kb-select" aria-label="Unidad del plazo"
                            [ngModel]="form.plazo.unit || 'DIAS'" (ngModelChange)="cambiarUnidad($event)">
                      <option value="DIAS">días</option>
                      <option value="HORAS">horas</option>
                    </select>
                    <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                  </div>
                </div>
                <p class="kb-hint">{{ form.plazo.unit === 'HORAS' ? (form.business_model === 'COBRANZA' ? 'Desde la hora exacta de cada cobro.' : 'En cesión de deuda se paga por día: 24 horas = 1 día.') : 'Días calendario; la hora no cuenta.' }}</p>
              </div>
              <div>
                <label class="kb-label" for="cpTipo">Forma de cálculo</label>
                <div class="kb-select-envoltorio">
                  <select id="cpTipo" class="kb-select" [(ngModel)]="form.plazo.type_calc">
                    <option value="PERCENTAGE">Porcentaje</option>
                    <option value="FIXED">Monto fijo</option>
                  </select>
                  <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                </div>
              </div>
              <div>
                <label class="kb-label" for="cpValor">
                  {{ form.plazo.type_calc === 'PERCENTAGE' ? 'Comisión %' : 'Comisión' }}
                  <span class="text-destructive">*</span>
                </label>
                <input id="cpValor" type="number" min="0" step="0.01" class="kb-input text-right tabular-nums"
                       [(ngModel)]="form.plazo.commission_value">
              </div>
              <div>
                <label class="kb-label" for="cpPlazoAlias">Nombre del plazo</label>
                <input id="cpPlazoAlias" type="text" class="kb-input" placeholder="Mensual"
                       [(ngModel)]="form.plazo.label">
                <p class="kb-hint">Si no, se lee del plazo («30 días», «24 horas»).</p>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="verNota || form.plazo.notes; else agregarNota">
          <label class="kb-label" for="cpPlazoNota">Nota <span class="font-normal text-muted-foreground">· opcional</span></label>
          <input id="cpPlazoNota" type="text" class="kb-input" placeholder="Algo que quieras dejar escrito en esta versión"
                 [(ngModel)]="form.plazo.notes">
        </div>
        <ng-template #agregarNota>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm !px-0 underline" (click)="verNota = true">
            <i class="far fa-sticky-note" aria-hidden="true"></i>Agregar una nota</button>
        </ng-template>
      </div>

      <aside class="cp-lado" role="status" aria-live="polite">
        <h3 class="cp-lado-rotulo">Así queda</h3>
        <ng-container *ngIf="asiQuedaPlazo as r; else sinPlazo">
          <p class="cp-cifra tabular-nums">{{ r.comision }}<small>de comisión</small></p>
          <dl class="cp-datos">
            <dt>Plazo</dt><dd>{{ r.plazo }}</dd>
            <dt>Se le paga</dt><dd>{{ r.cuando }}</dd>
            <dt>Sobre</dt><dd>{{ r.base }}</dd>
            <dt>Fin de semana</dt><dd>{{ r.habil }}</dd>
          </dl>
          <p class="cp-lado-pie" *ngIf="form.especial.activo"><span class="kb-badge kb-badge-alerta">Especial</span> La versión queda marcada y pide motivo.</p>
        </ng-container>
        <ng-template #sinPlazo><p class="m-0 text-sm text-muted-foreground">Elige un plazo para ver la comisión.</p></ng-template>
        <p class="cp-cambio" *ngIf="vigente && !esPropuesta">
          <i class="fas fa-history" aria-hidden="true"></i>Hoy rige <span class="tabular-nums">{{ comisionVigente() }}</span>
          <span class="font-mono text-xs">{{ vigente.version.code }}</span></p>
      </aside>
    </section>

    <!-- ══ 2 · Cobros ══════════════════════════════════════════════════════════
         🔴 REGLA DE JUAN, 2026-09-28: el cargo por uso (hoy `flat_fee`) es el
         primer renglón, junto con los demás conceptos. Se sigue GUARDANDO en
         `flat_fee`: lo leen la caja y la pausa del cargo por uso del comercio.

         UNA sola tabla, todos los renglones con el mismo formato: Concepto ·
         Monto (la unidad ADENTRO del campo, `InputGroup`) · Cuándo · En la
         venta de ejemplo · Quitar. «Agregar un cobro» agrega un renglón
         editable a esta misma tabla — no hay un formulario aparte. -->
    <section *ngSwitchCase="'cobros'" class="space-y-[20px]">

      <div class="kb-tabla-plana">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Concepto</th>
              <th class="kb-th">Monto</th>
              <th class="kb-th">Cuándo</th>
              <th class="kb-th kb-th-num">En la venta de ejemplo</th>
              <th class="kb-th kb-th-acciones">Quitar</th>
            </tr>
          </thead>
          <tbody>
            <!-- El cargo por uso: siempre el primer renglón, no se quita. -->
            <tr class="kb-tr">
              <td class="kb-td">
                <span class="kb-td-titulo">Cargo por uso</span>
                <p class="kb-td-sub">Por cada operación.</p>
              </td>
              <td class="kb-td">
                <label class="sr-only" for="cpFijo">Monto del cargo por uso</label>
                <div class="flex h-9 w-[160px] items-stretch overflow-hidden rounded-md border
                            border-input bg-background shadow-sm focus-within:border-ring
                            focus-within:ring-2 focus-within:ring-ring/40">
                  <input id="cpFijo" type="number" min="0" step="0.01"
                         class="kb-input min-w-0 flex-1 rounded-none border-0 text-right tabular-nums
                                shadow-none focus-visible:border-0 focus-visible:ring-0"
                         [(ngModel)]="form.flat_fee.value">
                  <span class="flex items-center border-l border-input bg-muted/40 px-2 text-xs
                               text-muted-foreground">{{ form.flat_fee.type_calc === 'PERCENTAGE' ? '%' : 'USD' }}</span>
                </div>
                <!-- Juan, 2026-10-08: monto fijo en dólares o porcentaje de la venta. -->
                <div class="cp-seg mt-1.5" role="group" aria-label="Unidad del cargo por uso">
                  <button type="button" [class.cp-seg-si]="form.flat_fee.type_calc !== 'PERCENTAGE'"
                          (click)="form.flat_fee.type_calc = 'FIXED'; guardarBorrador()">USD</button>
                  <button type="button" [class.cp-seg-si]="form.flat_fee.type_calc === 'PERCENTAGE'"
                          (click)="form.flat_fee.type_calc = 'PERCENTAGE'; guardarBorrador()">% de la venta</button>
                </div>
              </td>
              <td class="kb-td">
                <label class="sr-only" for="cpFijoCuando">Momento de cobro del cargo por uso</label>
                <div class="kb-select-envoltorio w-[240px]">
                  <select id="cpFijoCuando" class="kb-select" [(ngModel)]="form.flat_fee.charged_with">
                    <option value="INITIAL">Con la inicial, en la venta</option>
                    <option value="SETTLEMENT">Se descuenta al liquidarle</option>
                  </select>
                  <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                </div>
                <!-- Ángela: solo en cobranza, «al liquidar» y con cargo. Sin campo = con el primer abono (como siempre). -->
                <div class="mt-2" *ngIf="cobroDiaSiguienteAplica">
                  <label class="kb-campo-et" for="cpFijoCobro">¿Cuándo se cobra?</label>
                  <div class="kb-select-envoltorio w-[240px]">
                    <select id="cpFijoCobro" class="kb-select" [ngModel]="form.flat_fee.cobro || ''"
                            (ngModelChange)="form.flat_fee.cobro = $event; guardarBorrador()">
                      <option value="">Con el primer abono de la venta</option>
                      <option value="DIA_SIGUIENTE">Al día siguiente de la venta</option>
                    </select>
                    <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                  </div>
                  <p class="kb-td-sub m-0 mt-1">Sin esperar a que el cliente pague.</p>
                </div>
              </td>
              <td class="kb-td kb-td-num">{{ fijoSimulado() | number:'1.2-2' }}</td>
              <td class="kb-td-acciones"><span class="kb-td-sub">—</span></td>
            </tr>

            <!-- Los demás conceptos: cada renglón se edita en la misma tabla. -->
            <tr class="kb-tr last:border-b-0" *ngFor="let c of form.charges; let i = index"
                [ngClass]="{'kb-tr-atenuada': c.status === false}">
              <td class="kb-td">
                <label class="sr-only" [for]="'cpConcepto' + i">Concepto</label>
                <input [id]="'cpConcepto' + i" type="text" class="kb-input min-w-[11rem]" placeholder="Afiliación mensual"
                       [(ngModel)]="c.concept">
                <p class="kb-error" role="alert" *ngIf="!c.concept?.trim()">Falta el nombre del concepto</p>
                <label class="sr-only" [for]="'cpDescripcion' + i">Descripción</label>
                <input [id]="'cpDescripcion' + i" type="text" class="kb-input mt-[6px] h-7 text-xs"
                       placeholder="Descripción — opcional" [(ngModel)]="c.description">
              </td>
              <td class="kb-td">
                <div class="flex h-9 w-[160px] items-stretch overflow-hidden rounded-md border
                            border-input bg-background shadow-sm focus-within:border-ring
                            focus-within:ring-2 focus-within:ring-ring/40"
                     [ngClass]="{'border-destructive': c.value === null || c.value === '' || +c.value < 0}">
                  <span *ngIf="c.type_calc === 'FIXED'" class="flex items-center border-r border-input
                               bg-muted/40 px-2 text-xs text-muted-foreground">USD</span>
                  <input [id]="'cpMonto' + i" type="number" min="0" step="0.01"
                         class="kb-input min-w-0 flex-1 rounded-none border-0 text-right tabular-nums
                                shadow-none focus-visible:border-0 focus-visible:ring-0"
                         [(ngModel)]="c.value">
                  <span *ngIf="c.type_calc === 'PERCENTAGE'" class="flex items-center border-l border-input
                               bg-muted/40 px-2 text-xs text-muted-foreground">%</span>
                </div>
                <p class="kb-error" role="alert"
                   *ngIf="c.value === null || c.value === '' || +c.value < 0">Falta el monto</p>
                <div class="kb-select-envoltorio mt-[6px] w-[240px]">
                  <select [id]="'cpTipo' + i" class="kb-select" [(ngModel)]="c.type_calc">
                    <option value="FIXED">Monto fijo</option>
                    <option value="PERCENTAGE">Porcentaje</option>
                  </select>
                  <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                </div>
                <div class="kb-select-envoltorio mt-[6px] w-[240px]" *ngIf="c.type_calc === 'PERCENTAGE'">
                  <select [id]="'cpBase' + i" class="kb-select" [(ngModel)]="c.base">
                    <option value="SALE">Sobre el monto vendido</option>
                    <option value="FINANCED">Sobre el saldo a financiar</option>
                    <option value="COLLECTED">Sobre lo cobrado</option>
                  </select>
                  <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                </div>
              </td>
              <td class="kb-td">
                <div class="kb-select-envoltorio w-[240px]">
                  <select [id]="'cpCuando' + i" class="kb-select" [(ngModel)]="c.charged_with">
                    <option value="SETTLEMENT">Al liquidarle</option>
                    <option value="INITIAL" disabled>Con la inicial</option>
                  </select>
                  <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                </div>
                <!-- D6: los cobros de esta tabla solo se descuentan al liquidar; con la inicial va el cargo por uso. -->
                <p class="kb-hint !mt-1">Los cobros se descuentan al liquidarle; con la inicial solo el cargo por uso.</p>
              </td>
              <td class="kb-td kb-td-num">{{ montoConcepto(c) | number:'1.2-2' }}</td>
              <td class="kb-td-acciones">
                <div class="kb-acciones-grupo">
                  <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon"
                          [title]="c.status === false ? 'Reactivar el concepto' : 'Pausar el concepto'"
                          [attr.aria-label]="(c.status === false ? 'Reactivar el concepto ' : 'Pausar el concepto ') + (c.concept || 'sin nombre')"
                          (click)="alternarConcepto(i)">
                    <i class="fas" [ngClass]="c.status === false ? 'fa-play' : 'fa-pause'"
                       aria-hidden="true"></i></button>
                  <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon text-destructive"
                          title="Quitar el concepto"
                          [attr.aria-label]="'Quitar el concepto ' + (c.concept || 'sin nombre')"
                          (click)="quitarConcepto(i)">
                    <i class="fas fa-trash-alt" aria-hidden="true"></i></button>
                </div>
              </td>
            </tr>
            <tr class="kb-tr font-semibold last:border-b-0" *ngIf="form.charges.length">
              <td class="kb-td">Total de cobros</td>
              <td class="kb-td"></td>
              <td class="kb-td"></td>
              <td class="kb-td kb-td-num">{{ (fijoSimulado() + totalConceptos) | number:'1.2-2' }}</td>
              <td class="kb-td"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="agregarCobro()">
          <i class="fas fa-plus" aria-hidden="true"></i>Agregar un cobro
        </button>
      </div>

      <!-- Juan, 2026-10-08: lo elegido se dice abajo, con la venta de ejemplo. -->
      <div class="cp-resultado" role="status">{{ fraseCargo }}</div>
    </section>

    <!-- ══ 3 · Modelos ═════════════════════════════════════════════════════════
         🔴 REGLA DE JUAN, 2026-09-28: los modelos que usa el comercio, dentro
         de las condiciones. Por ahora queda PACTADO: la liquidación todavía no
         descuenta el cobro por modelo — se lo dice con esas palabras. -->
    <section *ngSwitchCase="'modelos'" class="space-y-[20px]">
      <p class="kb-hint m-0">
        <b>Queda pactado: la liquidación todavía no descuenta el cobro por modelo.</b>
      </p>

      <div class="kb-tabla-plana">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Modelo</th>
              <th class="kb-th">La usa</th>
              <th class="kb-th">Se cobra</th>
              <th class="kb-th">Monto o %</th>
              <th class="kb-th">Cuándo</th>
            </tr>
          </thead>
          <tbody>
            <tr class="kb-tr last:border-b-0" *ngFor="let m of form.modelos">
              <td class="kb-td kb-td-titulo">{{ nombreModelo(m.codigo) }}</td>
              <td class="kb-td">
                <button type="button" role="switch" class="cc-switch"
                        [id]="'cpUsa-' + m.codigo"
                        [attr.aria-checked]="m.usa" [class.cc-switch-on]="m.usa"
                        [attr.aria-label]="'La usa ' + nombreModelo(m.codigo)"
                        (click)="alternarUsaModelo(m)">
                  <span class="cc-switch-bolita" aria-hidden="true"></span>
                </button>
              </td>
              <td class="kb-td">
                <button type="button" role="switch" class="cc-switch" *ngIf="m.usa"
                        [attr.aria-checked]="m.cobra" [class.cc-switch-on]="m.cobra"
                        [attr.aria-label]="'Se cobra ' + nombreModelo(m.codigo)"
                        (click)="alternarCobraModelo(m)">
                  <span class="cc-switch-bolita" aria-hidden="true"></span>
                </button>
                <span class="kb-td-sub" *ngIf="!m.usa">—</span>
              </td>
              <td class="kb-td">
                <ng-container *ngIf="m.usa && m.cobra; else sinCobroModelo">
                  <input type="number" min="0" step="0.01"
                         class="kb-input text-right tabular-nums w-[240px]"
                         [ngClass]="{'kb-input-invalido': m.cargo.value === null || m.cargo.value === ''}"
                         [attr.aria-label]="'Monto del cobro de ' + nombreModelo(m.codigo)"
                         [(ngModel)]="m.cargo.value">
                  <div class="kb-select-envoltorio mt-[8px] w-[240px]">
                    <select class="kb-select"
                            [attr.aria-label]="'Forma de cálculo del cobro de ' + nombreModelo(m.codigo)"
                            [(ngModel)]="m.cargo.type_calc">
                      <option value="FIXED">Monto fijo</option>
                      <option value="PERCENTAGE">Porcentaje</option>
                    </select>
                    <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                  </div>
                </ng-container>
                <ng-template #sinCobroModelo><span class="kb-td-sub">—</span></ng-template>
              </td>
              <td class="kb-td">
                <div class="kb-select-envoltorio w-[240px]" *ngIf="m.usa && m.cobra">
                  <select class="kb-select"
                          [attr.aria-label]="'Momento de cobro de ' + nombreModelo(m.codigo)"
                          [(ngModel)]="m.cargo.charged_with">
                    <option value="SETTLEMENT">Al liquidarle</option>
                    <option value="INITIAL">Con la inicial</option>
                  </select>
                  <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                </div>
                <span class="kb-td-sub" *ngIf="!(m.usa && m.cobra)">—</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- ══ 4 · Modelo y liquidación (minuta 07-oct) ════════════════════════════
         El modelo de negocio decide CÓMO se liquida; el plazo decide CUÁNDO. Ya no hay
         modelo de riesgo (siempre sin recurso) ni días de diferimiento; el momento solo se elige en cobranza (fase 2). -->
    <!-- Propuesta C (Mario, 30-oct: «Me gusta la C, con el resumen al lado»): las preguntas a la izquierda y, al lado,
         cómo queda. Sin plazo ni horas: «alli en ningun lado se deben ver 24 horas»; el plazo es de «Plazo y comisión». -->
    <section *ngSwitchCase="'riesgo'" class="cp-tipo max-w-[1080px]">
      <div class="space-y-[26px]">

        <fieldset class="space-y-[10px]">
          <legend class="cp-preg"><span class="cp-preg-n">1</span>¿Qué servicio se le presta?</legend>
          <div class="grid grid-cols-1 gap-[12px] sm:grid-cols-2">
            <label for="cpModeloCompra" class="flex cursor-pointer gap-3 rounded-xl border bg-card p-4 transition-colors hover:bg-accent/40"
                   [ngClass]="form.business_model === 'COMPRA_DEUDA' ? 'border-primary bg-primary/5 ring-1 ring-primary cp-op-si' : 'border-border'">
              <input id="cpModeloCompra" type="radio" name="cpModelo" value="COMPRA_DEUDA" class="kb-radio mt-0.5"
                     [(ngModel)]="form.business_model" (ngModelChange)="cambiarTipo()">
              <span class="cp-op-ico"><i class="fas fa-file-contract" aria-hidden="true"></i></span>
              <span><span class="text-sm font-semibold text-foreground">Cesión de deuda</span><span class="cp-op-tag">cesión de pagaré</span>
                <span class="kb-hint block !mt-1">CrediTotal le paga lo financiado, menos comisión y cargo, aunque el cliente no haya pagado. Sin recurso.</span></span>
            </label>
            <label for="cpModeloCobranza" class="flex cursor-pointer gap-3 rounded-xl border bg-card p-4 transition-colors hover:bg-accent/40"
                   [ngClass]="form.business_model === 'COBRANZA' ? 'border-primary bg-primary/5 ring-1 ring-primary cp-op-si' : 'border-border'">
              <input id="cpModeloCobranza" type="radio" name="cpModelo" value="COBRANZA" class="kb-radio mt-0.5"
                     [(ngModel)]="form.business_model" (ngModelChange)="cambiarTipo()">
              <span class="cp-op-ico"><i class="fas fa-hand-holding-usd" aria-hidden="true"></i></span>
              <span><span class="text-sm font-semibold text-foreground">Servicio de cobranza</span>
                <span class="kb-hint block !mt-1">CrediTotal cobra las cuotas y le liquida al comercio lo que corresponda.</span></span>
            </label>
          </div>
        </fieldset>

        <!-- La 2 cuelga de «Servicio de cobranza» (VEN-14) y lleva el momento: al cobrar, al vencer o al completar la cuota (CPC-26). -->
        <fieldset *ngIf="form.business_model === 'COBRANZA'" class="cp-dependiente space-y-[10px]">
          <legend class="cp-preg"><span class="cp-preg-n">2</span>¿Cuándo se le liquida?</legend>
          <div class="grid grid-cols-1 gap-[10px]">
            <label for="cpMomentoCobro" class="flex cursor-pointer gap-3 rounded-xl border bg-card p-4 transition-colors hover:bg-accent/40"
                   [ngClass]="form.moment === 'ON_COLLECTION' ? 'border-primary bg-primary/5 ring-1 ring-primary cp-op-si' : 'border-border'">
              <input id="cpMomentoCobro" type="radio" name="cpMomento" value="ON_COLLECTION" class="kb-radio mt-0.5"
                     [(ngModel)]="form.moment">
              <span class="cp-op-ico"><i class="fas fa-coins" aria-hidden="true"></i></span>
              <span><span class="text-sm font-semibold text-foreground">Al cobrar</span>
                <span class="kb-hint block !mt-1">Liquidación continua: se le liquida cada abono; si el cliente no paga, esa parte no se liquida.</span></span>
            </label>
            <label for="cpMomentoVencimiento" class="flex cursor-pointer gap-3 rounded-xl border bg-card p-4 transition-colors hover:bg-accent/40"
                   [ngClass]="form.moment === 'ON_DUE_DATE' ? 'border-primary bg-primary/5 ring-1 ring-primary cp-op-si' : 'border-border'">
              <input id="cpMomentoVencimiento" type="radio" name="cpMomento" value="ON_DUE_DATE" class="kb-radio mt-0.5"
                     [(ngModel)]="form.moment">
              <span class="cp-op-ico"><i class="fas fa-calendar-day" aria-hidden="true"></i></span>
              <span><span class="text-sm font-semibold text-foreground">Al vencer la cuota</span>
                <span class="kb-hint block !mt-1">Cuota completa, pague o no el cliente.</span></span>
            </label>
            <label for="cpMomentoCuotaCompleta" class="flex cursor-pointer gap-3 rounded-xl border bg-card p-4 transition-colors hover:bg-accent/40"
                   [ngClass]="form.moment === 'ON_INSTALLMENT_PAID' ? 'border-primary bg-primary/5 ring-1 ring-primary cp-op-si' : 'border-border'">
              <input id="cpMomentoCuotaCompleta" type="radio" name="cpMomento" value="ON_INSTALLMENT_PAID" class="kb-radio mt-0.5"
                     [(ngModel)]="form.moment">
              <span class="cp-op-ico"><i class="fas fa-check-double" aria-hidden="true"></i></span>
              <span><span class="text-sm font-semibold text-foreground">Al completar la cuota</span>
                <span class="kb-hint block !mt-1">Cuota completa, no por cada abono; si queda a medias, todavía no se liquida.</span></span>
            </label>
          </div>
        </fieldset>
      </div>

      <aside class="cp-lado" role="status" aria-live="polite">
        <h3 class="cp-lado-rotulo">Así se le liquida</h3>
        <p class="m-0 text-sm text-foreground">{{ fraseModelo }}</p>
        <ol class="cp-linea">
          <li *ngFor="let h of hitosModelo; let ultimo = last" class="cp-hito" [class.cp-hito-fin]="ultimo">
            <b><i class="fas {{ h.ico }}" aria-hidden="true"></i>{{ h.tit }}</b>
            <span>{{ h.sub }}</span>
          </li>
        </ol>
        <p class="cp-lado-pie"><i class="far fa-clock" aria-hidden="true"></i>
          La liquidación se realiza según los plazos comprometidos en el contrato con el comercio.</p>
      </aside>
    </section>

    <!-- ══ Contrato firmado (sólo en el alta): el archivo lo pone el padre ══
         o32 (Adrián, 13-oct): sin «Referencia del contrato». El campo sigue en el formulario (vacío en un alta, el de la versión anterior en una nueva) y el núcleo lo acepta nulo. -->
    <section *ngSwitchCase="'contrato'" class="max-w-[760px] space-y-[20px]">
      <ng-content select="[paso-contrato]"></ng-content>
    </section>

    <!-- ══ 5 · Revisar ═════════════════════════════════════════════════════════
         Arriba, en dos columnas: la vigencia y el resumen · la venta de ejemplo.
         Abajo, en 'version': los cambios respecto de la vigente y, JUSTO encima
         del botón, el «no estás cambiando nada». -->
    <section *ngSwitchCase="'revisar'" class="space-y-[32px]">

      <div class="grid grid-cols-1 gap-[32px]" [ngClass]="{'lg:grid-cols-2': !esPropuesta}">

        <div class="space-y-[24px]">
          <!-- En el alta (Juan, 2026-10-08) no van ni la fecha (la elige el aprobador final) ni la
               referencia del contrato (se pide en «Contrato firmado»). -->
          <div class="kb-seccion" *ngIf="!esPropuesta">
            <div class="kb-seccion-regla">
              <span class="kb-seccion-rotulo">Vigencia</span><span class="kb-seccion-linea" aria-hidden="true"></span>
            </div>
            <div class="grid grid-cols-1 gap-[20px] sm:grid-cols-2">
              <div>
                <label class="kb-label" for="cpNombreVersion">Nombre de la versión <span class="text-destructive">*</span></label>
                <input id="cpNombreVersion" type="text" class="kb-input" [(ngModel)]="form.version.name">
                <p class="kb-hint">Cómo se la va a reconocer en el historial.</p>
              </div>
              <div>
                <label class="kb-label" for="cpDesde">Rige desde <span class="text-destructive">*</span></label>
                <input id="cpDesde" type="date" class="kb-input tabular-nums"
                       [ngClass]="{'kb-input-invalido': fechaInvalida}" [(ngModel)]="form.version.date_init">
                <p class="kb-error" *ngIf="fechaInvalida">
                  Tiene que ser posterior al {{ vigente.version.date_init | date:'dd/MM/yyyy' }},
                  que es cuando empezó la vigente.
                </p>
                <!-- Dice dos cosas que la etiqueta no dice: que ese día se cierra la anterior, y
                     que hasta que empiece todavía se puede cancelar. En 'propuesta' no hay una
                     vigente que se cierre: es otra frase. -->
                <p class="kb-hint" *ngIf="!fechaInvalida && !esPropuesta">
                  Ese día se cierra la versión que rige hoy. Si es una fecha futura, la versión queda
                  «futura» y todavía se puede cancelar.
                </p>
                <p class="kb-hint" *ngIf="esPropuesta">
                  Desde cuándo van a regir estas condiciones, si se aprueba el alta.
                </p>
              </div>
            </div>
          </div>

          <div class="kb-seccion">
            <div class="kb-seccion-regla">
              <span class="kb-seccion-rotulo">Lo que se va a guardar</span><span class="kb-seccion-linea" aria-hidden="true"></span>
            </div>
            <!-- Grilla pareja de tres columnas: etiqueta · valor · Cambiar (siempre a la derecha,
                 siempre el mismo botón). -->
            <div class="grid grid-cols-[minmax(0,150px)_1fr_auto] items-center gap-x-[16px] gap-y-[12px]">
              <span class="kb-dato-et">Plazo y comisión</span>
              <span class="kb-dato-val tabular-nums">{{ resumenPlazo }}</span>
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm justify-self-end" (click)="irA('plazo')">Cambiar</button>

              <span class="kb-dato-et">Cobros</span>
              <span class="kb-dato-val tabular-nums">{{ resumenCobros }}</span>
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm justify-self-end" (click)="irA('cobros')">Cambiar</button>

              <span class="kb-dato-et">Esquema de liquidación</span>
              <span class="kb-dato-val tabular-nums">{{ resumenRiesgo }}</span>
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm justify-self-end" (click)="irA('riesgo')">Cambiar</button>

              <span class="kb-dato-et">Liquidación</span>
              <span class="kb-dato-val tabular-nums">{{ resumenLiquidacion }}</span>
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm justify-self-end" (click)="irA('riesgo')">Cambiar</button>

              <ng-container *ngIf="esPropuesta">
                <span class="kb-dato-et">Canales de venta</span>
                <span class="kb-dato-val">{{ nombresCanales }}</span>
                <span class="justify-self-end text-xs text-muted-foreground">en «Canales de venta»</span>

                <span class="kb-dato-et">Contrato firmado</span>
                <span class="kb-dato-val" [class.kb-texto-alerta]="!contratoCargado">{{ contratoCargado ? 'Cargado' : 'Falta: súbelo antes de decidir' }}{{ form.contract_reference ? ' · ' + form.contract_reference : '' }}</span>
                <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm justify-self-end" (click)="irA('contrato')">Cambiar</button>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- La venta de ejemplo. Existe porque la elección de la BASE es donde está el dinero
             y no es evidente. En el alta no va (Juan, 2026-10-08: «quítame el cálculo»). -->
        <div class="kb-seccion" *ngIf="!esPropuesta">
          <div class="kb-seccion-regla">
            <span class="kb-seccion-rotulo">El cálculo, con una venta de ejemplo</span><span class="kb-seccion-linea" aria-hidden="true"></span>
          </div>
          <div class="grid grid-cols-1 gap-[20px] sm:grid-cols-3">
            <div>
              <label class="kb-label" for="cpSimVenta">Venta de ejemplo</label>
              <input id="cpSimVenta" type="number" min="0" step="1"
                     class="kb-input text-right tabular-nums" [(ngModel)]="sim.venta">
            </div>
            <div>
              <label class="kb-label" for="cpSimInicial">Inicial</label>
              <input id="cpSimInicial" type="number" min="0" step="1"
                     class="kb-input text-right tabular-nums" [(ngModel)]="sim.inicial">
            </div>
            <div>
              <span class="kb-label">Saldo a financiar</span>
              <p class="kb-input m-0 flex items-center justify-end tabular-nums text-muted-foreground">
                {{ saldoAFinanciar | number:'1.2-2' }}
              </p>
            </div>
          </div>

          <div class="kb-tabla-plana">
            <table class="kb-table">
              <thead class="kb-thead">
                <tr>
                  <th class="kb-th">Concepto</th>
                  <th class="kb-th">Base de cálculo</th>
                  <th class="kb-th kb-th-num">Monto</th>
                  <th class="kb-th">Cuándo entra</th>
                </tr>
              </thead>
              <tbody>
                <tr class="kb-tr">
                  <td class="kb-td kb-td-titulo">Comisión</td>
                  <td class="kb-td tabular-nums">
                    <span *ngIf="form.plazo.type_calc === 'PERCENTAGE'">
                      {{ montoBase() | number:'1.2-2' }} · {{ ETIQUETAS[form.plazo.base] }}
                    </span>
                    <span class="kb-td-sub" *ngIf="form.plazo.type_calc === 'FIXED'">
                      monto fijo, no depende de la venta
                    </span>
                  </td>
                  <td class="kb-td kb-td-num">{{ comisionSimulada() | number:'1.2-2' }}</td>
                  <td class="kb-td kb-td-sub">{{ cuandoComision }}</td>
                </tr>
                <tr class="kb-tr" *ngIf="fijoSimulado()">
                  <td class="kb-td kb-td-titulo">Cargo por uso</td>
                  <td class="kb-td kb-td-sub">por operación</td>
                  <td class="kb-td kb-td-num">{{ fijoSimulado() | number:'1.2-2' }}</td>
                  <td class="kb-td kb-td-sub">{{ cuandoFijo }}</td>
                </tr>
                <tr class="kb-tr" *ngFor="let c of form.charges">
                  <td class="kb-td kb-td-titulo">{{ c.concept }}</td>
                  <td class="kb-td tabular-nums">
                    <span *ngIf="c.type_calc === 'PERCENTAGE'">
                      {{ montoBase(c.base) | number:'1.2-2' }} · {{ ETIQUETAS[c.base] }}
                    </span>
                    <span class="kb-td-sub" *ngIf="c.type_calc === 'FIXED'">monto fijo</span>
                  </td>
                  <td class="kb-td kb-td-num">{{ montoConcepto(c) | number:'1.2-2' }}</td>
                  <td class="kb-td kb-td-sub">
                    {{ ETIQUETAS[c.charged_with] }}<span *ngIf="c.status === false"> · pausado</span>
                  </td>
                </tr>
                <tr class="kb-tr font-semibold last:border-b-0">
                  <td class="kb-td">Total a cobrarle al comercio</td>
                  <td class="kb-td"></td>
                  <td class="kb-td kb-td-num">{{ totalSimulado() | number:'1.2-2' }}</td>
                  <td class="kb-td"></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="kb-aviso kb-aviso-info" *ngIf="totalVigente !== null">
            <i class="fas fa-balance-scale mt-0.5" aria-hidden="true"></i>
            <div>
              <p class="kb-aviso-titulo">Contra lo que rige hoy</p>
              <p class="m-0 tabular-nums">
                Con la condición vigente esta misma venta cobraría
                <b>{{ totalVigente | number:'1.2-2' }}</b>; con la nueva,
                <b>{{ totalSimulado() | number:'1.2-2' }}</b>.
                <span *ngIf="diferencia > 0"> Son <b>{{ diferencia | number:'1.2-2' }} más</b>.</span>
                <span *ngIf="diferencia < 0"> Son <b>{{ -diferencia | number:'1.2-2' }} menos</b>.</span>
                <span *ngIf="diferencia === 0"> Es lo mismo.</span>
              </p>
            </div>
          </div>

          <p class="kb-hint" *ngIf="form.plazo.base === 'COLLECTED'">
            Con base «lo cobrado», el monto se completa <b>a medida que el cliente paga</b>: lo de
            arriba es el total estimado al final del crédito, no lo que entra el día de la venta.
          </p>
        </div>
      </div>

      <!-- Cambios respecto de la vigente — 🔴 lo que evita crear una versión creyendo que se
           cambió una cosa y haber cambiado otra. Solo en 'version'. -->
      <div class="kb-seccion" *ngIf="vigente && !esPropuesta && cambios.length">
        <div class="kb-seccion-regla">
          <span class="kb-seccion-rotulo">Cambios respecto de {{ vigente.version.code }}
            · <span class="tabular-nums">{{ cambios.length }}</span></span>
          <span class="kb-seccion-linea" aria-hidden="true"></span>
        </div>
        <div class="kb-tabla-plana">
          <table class="kb-table">
            <thead class="kb-thead">
              <tr>
                <th class="kb-th">Campo</th>
                <th class="kb-th">Antes</th>
                <th class="kb-th">Ahora</th>
              </tr>
            </thead>
            <tbody>
              <tr class="kb-tr last:border-b-0" *ngFor="let c of cambios">
                <td class="kb-td kb-td-titulo">{{ c.campo }}</td>
                <td class="kb-td kb-td-sub tabular-nums">{{ c.antes }}</td>
                <td class="kb-td font-medium tabular-nums">{{ c.ahora }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- JUSTO encima del botón. -->
      <div class="kb-aviso kb-aviso-alerta" *ngIf="sinCambios">
        <i class="fas fa-exclamation-triangle mt-0.5" aria-hidden="true"></i>
        <div>
          <p class="kb-aviso-titulo">No estás cambiando nada</p>
          <p class="m-0">El formulario arranca copiado de la versión vigente, y esta versión sería
             <b>idéntica a {{ vigente.version.code }}</b>. Crearla cierra la vigente y abre otra
             igual: casi siempre es un error. Revisa qué querías cambiar.</p>
        </div>
      </div>
    </section>
  </ng-container>

  <!-- ══ Barra de acciones ════════════════════════════════════════════════════
       🔴 Cero `Swal`: el «¿Crear la versión?» es este mismo panel, en dos pasos. -->
  <div class="kb-barra-pie">
    <ng-container *ngIf="!confirmandoCrear">
      <p class="kb-barra-nota m-0">
        <span class="kb-td-alerta font-medium" *ngIf="!esUltimo && faltaEnPaso(paso)">
          <i class="fas fa-exclamation-triangle" aria-hidden="true"></i> {{ faltaEnPaso(paso) }}
        </span>
        <!-- El rechazo del servidor (lo pasa el padre por `[error]`), donde se guarda. -->
        <span class="kb-texto-peligro font-medium" role="alert" *ngIf="esUltimo && error">
          <i class="fas fa-exclamation-triangle" aria-hidden="true"></i> {{ error }}
        </span>
        <ng-container *ngIf="esUltimo && !error">
          <span class="kb-td-alerta font-medium" *ngIf="!valido || fechaInvalida">
            <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
            {{ fechaInvalida ? 'La fecha de inicio no es válida' : faltaParaCrear }}
          </span>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm ml-[4px]"
                  *ngIf="(!valido || fechaInvalida) && pasoConFalta as pf" (click)="irA(pf.clave)">
            Ir a «{{ pf.nombre }}»
          </button>
          <span *ngIf="valido && !fechaInvalida && !esPropuesta">Se creará sin aprobar. Aprobarla es el paso siguiente.</span>
        </ng-container>
      </p>
      <div class="flex flex-wrap items-center justify-end gap-2">
        <button type="button" class="kb-btn kb-btn-ghost" [disabled]="guardando" (click)="cancelar()">Cancelar</button>
        <button type="button" class="kb-btn kb-btn-outline" *ngIf="indice > 0" [disabled]="guardando"
                (click)="anterior()">
          <i class="fas fa-chevron-left" aria-hidden="true"></i>Anterior
        </button>
        <button type="button" class="kb-btn kb-btn-primary" *ngIf="!esUltimo"
                [disabled]="!!faltaEnPaso(paso)" (click)="siguiente()">
          Siguiente<i class="fas fa-chevron-right" aria-hidden="true"></i>
        </button>
        <!-- 'propuesta' (el alta): no hay vigente que cerrar, así que guarda directo, sin el
             panel de confirmación. -->
        <button type="button" class="kb-btn kb-btn-primary" *ngIf="esUltimo"
                [disabled]="!puedeGuardar" (click)="esPropuesta ? guardar() : pedirConfirmacion()">
          <i class="fas" [ngClass]="guardando ? 'fa-spinner fa-spin' : 'fa-check'" aria-hidden="true"></i>
          {{ esPropuesta ? (guardando ? 'Guardando…' : 'Guardar las condiciones') : 'Crear la versión' }}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="confirmandoCrear">
      <p class="kb-barra-nota m-0">
        ¿Crear la versión? Rige desde el
        <b class="tabular-nums">{{ form.version.date_init.split('-').reverse().join('/') }}</b>.
        <span *ngIf="vigente">La versión <b>{{ vigente.version.code }}</b> queda cerrada ese día.</span>
        Nace <b>sin aprobar</b>: aprobarla es el paso siguiente.
      </p>
      <div class="flex flex-wrap items-center justify-end gap-2">
        <button type="button" class="kb-btn kb-btn-outline" [disabled]="guardando"
                (click)="cancelarConfirmacion()">Revisar</button>
        <button type="button" class="kb-btn kb-btn-primary" [disabled]="guardando" (click)="guardar()">
          <i class="fas" [ngClass]="guardando ? 'fa-spinner fa-spin' : 'fa-check'" aria-hidden="true"></i>
          {{ guardando ? 'Creando…' : 'Sí, crear la versión' }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
